window.addEventListener('DOMContentLoaded', (e) => {
    const slideMain = new Swiper('#js-portable__kv__main', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        loop: true,
        // speedを0にするとautoplayが止まるので注意
        speed: 100,
        preventInteractionOnTransition: true,
        loopFillGroupWithBlank:1,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        effect: "fade",
        slideActiveClass: 'swiper-slide-active--main',
        navigation: {
            nextEl: '.js-portable__kv__sub__pagination__next',
        },
        pagination: {
            el: '.swiper-pagination--indicator',
            clickable: true,
            spaceBetween: 0,
        },
        on: {
            init: function() {
                const bullets = document.querySelectorAll('.swiper-pagination-bullet');
                bullets.forEach((bullet, index) => {
                    bullet.setAttribute('data-index', index + 1);
                });
                // スライド番号と総数を初期化
                initializePagination(this);

                //次の次のスライドにクラスを付与
                manageSlideClassesNextNext(this);
            },
            slideChange: function() {
                const bullets = document.querySelectorAll('.swiper-pagination-bullet');
                const activeBullet = document.querySelector('.swiper-pagination-bullet-active');

                // 1枚目のスライドに戻ってきたタイミングでdoneクラスとstartクラスをすべて削除
                if (activeBullet && activeBullet.getAttribute('data-index') === "1") {
                    bullets.forEach((bullet) => {
                        bullet.classList.remove('done', 'start');
                    });
                } else if (activeBullet && activeBullet.previousElementSibling) {
                    activeBullet.previousElementSibling.classList.add('done');
                }
                if (activeBullet) {
                    activeBullet.classList.remove('done');
                    activeBullet.classList.add('start');
                }
                // 1回目のスライドが終わった後の処理
                if (this.realIndex === 1) {
                    // mainスライドのクラスを削除
                    const firstMainSlide = document.querySelector('.js-portable__kv__main__slide--first');
                    if (firstMainSlide) {
                        firstMainSlide.classList.remove('js-portable__kv__main__slide--first');
                    }
                    // subスライドのクラスを削除
                    const firstSubSlide = document.querySelector('.js-portable__kv__sub__slide--first');
                    if (firstSubSlide) {
                        firstSubSlide.classList.remove('js-portable__kv__sub__slide--first');
                    }
                }
                // スライドのis-activeクラスを管理
                // mainSlideClassIsOut(this);
                //次の次のスライドにクラスを付与
                manageSlideClassesNextNext(this);
            }
        },
        breakpoints: {
            1024: {
                allowTouchMove: false,
            }
        }
    });

    let debounceTimer;
    const slideSub = new Swiper('#js-portable__kv__sub', {
        loop: true,
        loopFillGroupWithBlank: 1,
        speed: 100,
        preventInteractionOnTransition: true,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        allowTouchMove: false,
        effect: "fade",
        slideActiveClass: 'swiper-slide-active--sub',
        on: {
            init: function () {
                // 初期設定時にスライドインジケータを更新
                initializePagination(this);
            },
            //setTransitionかtransitionStartが最も速く実行される。
            //最後のスライドから最初に戻る際にsetTransitionは一瞬で2回実行されるためtransitionStartの方が実質速い。
            // setTransition: function () {
            //     console.log("sub-setTransition");
            // },
            transitionStart: function () {
                //debounce処理を実装して、最後の1回だけ実行
                //最後から最初に戻る際に一瞬で3回切り替えが実行されるため、activeな動画もnextの動画も開始位置が0になり停止したように見える。
                //その回避のためclearTimeoutで一瞬で実行されるものはキャンセルし最後に実行されるもの（次にactiveになる動画）に処理を限定させる。
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    const activeSlide = this.slides[this.activeIndex];
                    //getElementsByTagNameの方が高速なためタグで指定
                    activeSlide.getElementsByTagName('video')[0].currentTime = 0;
                }, 5); // 指定した秒に実行されるものはキャンセル
                // console.log("sub-transitionStart");
            },
            slideChange: function () {
                // スライドが変わるたびにスライドインジケータを更新
                updatePagination(this);
            }
        }
    });

    //商品タイトルのクリックによるスライドの切り替え=============================================================================
    let isSliding = false;
    // スライド移動関数
    function slideToWithLoop(slideIndex) {
        if (!isSliding) {
            slideMain.slideToLoop(slideIndex); // 正確なスライドに移動
            isSliding = true;
        }
    }
    // クリックイベント設定
    document.querySelectorAll('.js-portable__kv__sub__ttl__blk').forEach(button => {
        button.addEventListener('click', function() {
            const clickedBtnIndex = parseInt(this.getAttribute('data-btn')); // クリックした要素のdata-btnの値
            const activeSlideIndex = slideMain.realIndex; // 現在アクティブなスライドのインデックス

            // スライドが次か前かをチェック
            if (clickedBtnIndex === activeSlideIndex + 1 || (activeSlideIndex === slideMain.slides.length - 1 && clickedBtnIndex === 0)) {
                slideMain.slideNext(); // 次のスライドに移動
            } else if (clickedBtnIndex === activeSlideIndex - 1 || (activeSlideIndex === 0 && clickedBtnIndex === slideMain.slides.length - 1)) {
                slideMain.slidePrev(); // 前のスライドに移動
            } else {
                slideToWithLoop(clickedBtnIndex); // 指定のスライドに移動
            }
        });
    });
    // スライドアニメーション開始時にフラグ設定
    slideMain.on('slideChangeTransitionStart', () => {
        isSliding = true;
    });
    // スライドアニメーション終了時にフラグリセット
    slideMain.on('slideChangeTransitionEnd', () => {
        isSliding = false;
    });
    //controllerによるmainとsubの連動======================================================================================
    slideSub.controller.control = [slideMain];
    slideMain.controller.control = [slideSub];


    function manageSlideClassesNextNext(swiper) {
        // アクティブなスライドの次の次のスライドを取得
        const activeIndex = swiper.activeIndex;
        const slides = swiper.slides;
        const totalSlides = slides.length;

        // すべてのスライドから特定のクラスを一旦削除
        slides.forEach(slide => {
            slide.classList.remove('js-portable__kv__main__slide--next-next');  // 次の次のスライドに付与するクラス
        });

        // 次の次のスライドのインデックスを計算
        const nextNextIndex = (activeIndex + 2) % totalSlides;

        // 次の次のスライドにクラスを追加
        slides[nextNextIndex].classList.add('js-portable__kv__main__slide--next-next');
    }

    function initializePagination(swiper) {
        const paginationCount = document.getElementById('js-portable__kv__sub__pagination__count');
        const paginationLength = document.getElementById('js-portable__kv__sub__pagination__count__length');
        const totalSlides = swiper.slides.length;

        if (paginationCount && paginationLength) {
            // 初期化時に既存の要素をクリア
            paginationCount.innerHTML = '';

            // 初期のスライド番号を生成
            for (let i = 1; i <= totalSlides; i++) {
                const numElement = document.createElement('span');
                numElement.classList.add('portable__kv__sub__pagination__count__num');
                if (i === 1) {
                    numElement.classList.add('is-active');
                }
                numElement.textContent = i.toString().padStart(2, '0'); // 2桁にする
                paginationCount.appendChild(numElement);
            }

            // スライドの総数を表示
            paginationLength.textContent = `/${totalSlides.toString().padStart(2, '0')}`;
            paginationCount.appendChild(paginationLength); // 長さの要素を末尾に追加
        }
    }
    function updatePagination(swiper) {
        const paginationCount = document.getElementById('js-portable__kv__sub__pagination__count');
        const currentSlideIndex = swiper.realIndex;

        if (paginationCount) {
            const numElements = paginationCount.querySelectorAll('.portable__kv__sub__pagination__count__num');
            numElements.forEach((el, index) => {
                if (index === currentSlideIndex) {
                    el.classList.add('is-active');
                    el.classList.remove('is-out');
                } else if (el.classList.contains('is-active')) {
                    el.classList.remove('is-active');
                    el.classList.add('is-out');
                } else {
                    el.classList.remove('is-out');
                }
            });
        }
    }
    // function mainSlideClassIsOut(swiper) {
    //     const slides = swiper.slides;
    //     const activeSlide = slides[swiper.activeIndex];
    //     const previousSlide = slides[swiper.previousIndex];
    //
    //     if (previousSlide && previousSlide !== activeSlide) {
    //         previousSlide.classList.remove('swiper-slide-active--main');
    //         previousSlide.classList.add('is-out');
    //     }
    //
    //     if (activeSlide) {
    //         activeSlide.classList.add('swiper-slide-active--main');
    //     }
    // }
    //ボタンの連続クリックの無効化
    document.querySelectorAll('.js-clickProtection').forEach(clickProtection => {
        clickProtection.addEventListener('click', function() {
            // クリックされた要素とその他のボタンを取得
            const clickProtectionBtn = document.querySelectorAll('.js-clickProtection');

            // すべてのボタンにクリック防止のクラスを追加
            clickProtectionBtn.forEach(btn => {
                btn.classList.add('is-disabled');
            });

            // 指定した時間が経過したら、クラスを削除してクリック可能に
            setTimeout(() => {
                clickProtectionBtn.forEach(btn => {
                    btn.classList.remove('is-disabled');
                });
            }, 1000);
        });
    });

    //Uniのカラーバリエーション=============================================================================================
    const slideColor_uni = new Swiper('#js-portable__item__uniColor__in', {
        autoplay: {
            delay: 360,
            disableOnInteraction: false,
        },
        loop: true,
        speed: 360,
        slidesPerView: 1,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        effect: "fade",
        // on: {
        //     slideChange: function() {
        //         // 1回目のスライドが終わった後の処理
        //         if (this.realIndex === 1) {
        //             const firstSlide = document.querySelector('.js-portable__item__uniColor__in__slide--first');
        //             firstSlide.classList.remove('scroll-animate-picture');
        //         }
        //     }
        // }
    });

    // Intersection Observerを使用して、要素が表示領域に入ったらautoplayを開始する
    const swiperElement_uniColor = document.getElementById('js-portable__item__uniColor__in');

    // autoplayを一旦無効化
    slideColor_uni.autoplay.stop();

    // ユニークなObserverの設定
    const observerUniColor = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 表示領域に入った場合、autoplayを開始
                // 0.5秒後にautoplayを開始
                setTimeout(() => {
                    slideColor_uni.autoplay.start();
                }, 500);

                // autoplayが始まったら監視を解除
                observer.disconnect();
            }
        });
    }, {
        threshold: 1
    });

    // 監視を開始
    observerUniColor.observe(swiperElement_uniColor);

    // // 画面幅が1024px以上の時のみ、マウスホバー時にautoplayを開始・停止
    // if (window.innerWidth >= 1024) {
    //     // ホバー時にautoplayを開始
    //     swiperElement_uniColor.addEventListener('mouseenter', () => {
    //         slideColor_uni.autoplay.start();
    //     });
    //
    //     // ホバーが解除された時にautoplayを停止
    //     swiperElement_uniColor.addEventListener('mouseleave', () => {
    //         slideColor_uni.autoplay.stop();
    //     });
    // }
    //stickyの関係でPCの時に要素を移動======================================================================================
    function movePortableItem() {

        const pcLeft_kv = document.getElementById("js-portable-pcLeft__kv__in");
        const pcLeft_kv_subSlide = document.getElementById("js-portable__kv__sub");

        const portableItem = document.getElementById('js-portable-item');
        const portableItemPc = document.getElementById('js-portable-item-pc');

        if (window.innerWidth >= 1024) {
            if (pcLeft_kv && pcLeft_kv_subSlide && !pcLeft_kv.contains(pcLeft_kv_subSlide)) {
                pcLeft_kv.appendChild(pcLeft_kv_subSlide);
            }
            if (portableItem && portableItemPc && !portableItemPc.contains(portableItem)) {
                portableItemPc.appendChild(portableItem);
            }
        }
    }
    movePortableItem();
    //ウィンドウのリサイズ時に実行
    window.addEventListener('resize', movePortableItem);
    //スクロールアニメーションとblurぼかし処理=================================================================================
    let ticking = false;
    // スクロールアニメーション処理
    function handleScroll() {
        // テキストアニメーション処理
        const scroll_animate_txt = document.querySelectorAll('.scroll-animate-text');
        const scroll_animate_pic = document.querySelectorAll('.scroll-animate-picture');
        const windowHeight = window.innerHeight;

        // テキストアニメーション
        scroll_animate_txt.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('show');
            }
        });

        // 画像アニメーション
        scroll_animate_pic.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('show');
            }
        });

        // Blurアニメーション処理
        const portableItem = document.getElementById('js-portable-item');
        const portablePcLeftIn = document.getElementById('js-portable-pcLeft__in');
        const portablePcLeftInRect = portablePcLeftIn.getBoundingClientRect();
        const portableItemRect = portableItem.getBoundingClientRect();

        // 条件:
        // 1. portablePcLeftIn が画面上部に到達している
        // 2. portableItem の上部が portablePcLeftIn の下部を超えた
        if (portablePcLeftInRect.top <= 0 && portableItemRect.top <= portablePcLeftInRect.bottom) {
            portablePcLeftIn.classList.add('js-portable-pcLeft__in--blur');

            // スクロールの進行度に基づいて blur の値を調整
            const scrollRatio = Math.min(Math.max((windowHeight - portableItemRect.top) / windowHeight, 0), 1);
            const blurValue = (16 * scrollRatio); // 0px 〜 20px に変化
            portablePcLeftIn.style.setProperty('--blur-value', `${blurValue}px`);
        } else {
            portablePcLeftIn.classList.remove('js-portable-pcLeft__in--blur');
            portablePcLeftIn.style.setProperty('--blur-value', '0px');
        }

        ticking = false; // 処理完了後にtickingを解除
    }
    // スクロールの最適化
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }
    // スクロールイベントに対して関数を追加
    window.addEventListener('scroll', onScroll);
    //caravan swiper====================================================================================================
    const caravanSlide = new Swiper('#js-portable__item__caravan1', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loop: true,
        speed: 100,
        slidesPerView: 1,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        effect: "fade",
        slideActiveClass: 'swiper-slide-active--caravan',
        // on: {
        //     slideChange: function() {
        //         // 1回目のスライドが終わった後の処理
        //         if (this.realIndex === 1) {
        //             const firstMainSlide = document.querySelector('.js-portable__item__caravan1__slide--first');
        //             const firstMainSlide_picture_animate = document.querySelector('.js-portable__item__caravan1__slide--first .scroll-animate-picture');
        //             if (firstMainSlide) {
        //                 firstMainSlide.classList.remove('js-portable__item__caravan1__slide--first');
        //                 firstMainSlide_picture_animate.classList.remove('scroll-animate-picture');
        //             }
        //         }
        //     }
        // },
        breakpoints: {
            1024: {
                allowTouchMove: false, // 手動でのスワイプを禁止
            }
        }
    });
    //IntersectionObserverを設定して、要素が画面内に入ったらautoplayを開始
    const caravanSlide_observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                caravanSlide.autoplay.start(); // autoplayを開始
            } else {
                caravanSlide.autoplay.stop(); // 画面外に出たら自動再生を停止する場合はこの行を使用
            }
        });
    }, {
        threshold: 0.01 // 要素が1%見えたら処理を発動
    });
    // #js-portable__item__caravan1の要素を監視
    const caravanSlide_target = document.getElementById('js-portable__item__caravan1');
    if (caravanSlide_target) {
        caravanSlide_observer.observe(caravanSlide_target);
    }
    //スライド領域をクリックしたら次のスライドに進む
    document.getElementById('js-portable__item__caravan1').addEventListener('click', function() {
        caravanSlide.slideNext(); // 次のスライドに移動
    });
    //group img=========================================================================================================
    const portableGroup = document.getElementById('js-portable__group');
    const portableGroupImg = document.querySelector('.portable__group__img');
    const groupImg_observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                portableGroupImg.classList.add('animate'); // 画面に入ったらアニメーションを発動
            }
        });
    }, {
        threshold: 0.1 // 要素が10%見えたら発動
    });
    groupImg_observer.observe(portableGroup); // #js-portable__groupを監視

    //lineup============================================================================================================
    const lineupSlide = new Swiper('#js-portable__lineup__list', {
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        spaceBetween: 20,
        loop: false,
        speed: 1000,
        slidesPerView: 1.1,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideActiveClass: 'swiper-slide-active--lineup',
        on: {
            init: function() {
                adjustHeights();
            },
            resize: function() {
                adjustHeights();
            }
        },
        breakpoints: {
            744: {
                slidesPerView: 2.12,
                spaceBetween: 24,
            },
            1024: {
                allowTouchMove: false, // 手動でのスワイプを禁止
                slidesPerView: 3,
                spaceBetween: 28,
                on: {
                    // 1024px以上のブレークポイントでSwiperが初期化された後に高さを調整
                    init: function() {
                        adjustHeights();
                    }
                }
            }
        }
    });

    //高さを調整する関数
    function adjustHeights() {
        const lineupTops = document.querySelectorAll('.js-portable__lineup__list__slide__top');
        const lineupTitles = document.querySelectorAll('.js-portable__lineup__list__slide__ttl');
        const lineupSpecs = document.querySelectorAll('.js-portable__lineup__list__slide__spec');

        let lineupTopsHeight = 0;
        let lineupTitlesHeight = 0;
        let lineupSpecsHeight = 0;

        // すべてのトップ要素の高さを測定し、最大の高さを見つける
        lineupTops.forEach(element => {
            element.style.height = 'auto';
            const elementHeight = element.getBoundingClientRect().height;
            if (elementHeight > lineupTopsHeight) {
                lineupTopsHeight = elementHeight;
            }
        });

        // すべてのタイトル要素の高さを測定し、最大の高さを見つける
        lineupTitles.forEach(element => {
            element.style.height = 'auto';
            const elementHeight = element.getBoundingClientRect().height;
            if (elementHeight > lineupTitlesHeight) {
                lineupTitlesHeight = elementHeight;
            }
        });

        // すべてのspec要素の高さを測定し、最大の高さを見つける
        lineupSpecs.forEach(element => {
            element.style.height = 'auto';
            const elementHeight = element.getBoundingClientRect().height;
            if (elementHeight > lineupSpecsHeight) {
                lineupSpecsHeight = elementHeight;
            }
        });

        // 最大の高さに合わせて他のトップ要素の高さを設定
        lineupTops.forEach(element => {
            element.style.height = `${lineupTopsHeight}px`;
        });

        // 最大の高さに合わせて他のタイトル要素の高さを設定
        lineupTitles.forEach(element => {
            element.style.height = `${lineupTitlesHeight}px`;
        });

        // 最大の高さに合わせて他のSpec要素の高さを設定
        lineupSpecs.forEach(element => {
            element.style.height = `${lineupSpecsHeight}px`;
        });
    }
    // リサイズイベントを監視し、リサイズ時に関数を実行
    window.addEventListener('resize', function() {
        adjustHeights();
    });
    //instagram bg======================================================================================================
    const portableInstagram = document.getElementById('js-portable__instagram__pic');
    const portableInstagramImg = document.querySelector('.portable__instagram__pic__img');
    const portableInstagram_observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                portableInstagramImg.classList.add('animate');
            }
        });
    }, {
        threshold: 0.1 // 要素が10%見えたら発動
    });
    portableInstagram_observer.observe(portableInstagram);

    //カーソルアニメーション================================================================================================
    // 変数の宣言
    const cursor = document.getElementById("js-cursor");
    const cWidth = 8;
    const fWidth = 40;
    const delay = 10;
    let mouseX = 0;
    let mouseY = 0;
    let posX = 0;
    let posY = 0;
    let hasLoaded = false; // 初回実行のためのフラグ

    // TweenMaxを使ったアニメーションループ
    TweenMax.to({}, 0.001, {
        repeat: -1,
        onRepeat: function() {
            posX += (mouseX - posX) / delay;
            posY += (mouseY - posY) / delay;

            TweenMax.set(cursor, {
                css: {
                    left: mouseX - (cWidth / 2),
                    top: mouseY - (cWidth / 2)
                }
            });
        }
    });

    // マウスムーブイベント
    document.addEventListener("mousemove", function(e) {
        // マウスの位置を常に更新
        mouseX = e.clientX;
        mouseY = e.clientY;

        // 初回のマウス移動時にクラスを追加
        if (!hasLoaded) {
            cursor.classList.add("js-loaded"); // 初回でクラスを追加
            hasLoaded = true; // フラグをセットして初回以降の動作を防ぐ
        }
    });

    // "a"タグにマウスエンターとリーブのイベントを設定
    document.querySelectorAll("a").forEach(link => {
        link.addEventListener("mouseenter", function() {
            cursor.classList.add("is-link");
        });
        link.addEventListener("mouseleave", function() {
            cursor.classList.remove("is-link");
        });
    });
    // hover黒丸の要素
    document.querySelectorAll(".js-awsHeader__pc__menu").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".awsHeader__icon__in__blk").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".js-headerSearch-close").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".headerSearch__modal__inner__word__tag").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelector(".search__modal__inner__form__btn").classList.add("js-cursor-black");

    document.querySelectorAll(".js-cursor-black").forEach(link => {
        link.addEventListener("mouseenter", function() {
            cursor.classList.add("js-cursor-black--active");
        });
        link.addEventListener("mouseleave", function() {
            cursor.classList.remove("js-cursor-black--active");
        });
    });
    //Uniのカラースライドhover用
    document.querySelectorAll(".js-cursor-chooseColor").forEach(link => {
        link.addEventListener("mouseenter", function() {
            cursor.classList.add("js-cursor-chooseColor--active");
        });
        link.addEventListener("mouseleave", function() {
            cursor.classList.remove("js-cursor-chooseColor--active");
        });
    });
    //Caravanのスライドhover用
    const cursorAnywhere = document.querySelector(".js-cursor-anywhere");
    cursorAnywhere.addEventListener("mouseenter", function() {
        cursor.classList.add("js-cursor-anywhere--active");
    });
    cursorAnywhere.addEventListener("mouseleave", function() {
        cursor.classList.remove("js-cursor-anywhere--active");
    });
    //Candelaのスライドhover用
    const cursorLightUp = document.querySelector(".js-cursor-lightUp");
    cursorLightUp.addEventListener("mouseenter", function() {
        cursor.classList.add("js-cursor-lightUp--active");
    });
    cursorLightUp.addEventListener("mouseleave", function() {
        cursor.classList.remove("js-cursor-lightUp--active");
    });
});